module.exports = __webpack_public_path__ + "resources/img/img_dvision3_m.3cbcabf20f0fe1cdc5aa6608e3021447.png";